export default "__VITE_ASSET__CU1A2nXs__"